import {
  PanelBody,
  TextareaControl,
  TextControl
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { t } from "drupal";



/**
*  This is the side panel for the call out box.
*  You can add any settings, instructions, or errror messagges below.
**/


function BioBoxSidePanel({

}) {

  return (
    <InspectorControls>
      <PanelBody title={t("Biobox")} initialOpen>
        {/* Text Content */}

        <p>Click the "Add block" button inside the call out box to add blocks.</p>

      </PanelBody>

    </InspectorControls>
  );
}

export default BioBoxSidePanel;
